export class Profissao {
    public Id: number;
    public Descricao: string;
    public CodigoPagtur: string;
}
